import { motion } from "framer-motion";
import { FaRegHeart, FaStar } from "react-icons/fa";
import poster from "../../assets/images/toddlers-game.jpg";
import trailer from "../../assets/videos/toddlersvideo.mp4";
import { useRef, useEffect, useState } from "react";
import { VolumeX, Volume2 } from "lucide-react";

import noads from "../../assets/images/Blogs/noads.jpeg";
import add from "../../assets/images/Blogs/add-nos.jpeg";
import count from "../../assets/images/Blogs/count-nos.jpeg";
import subtract from "../../assets/images/Blogs/subtract-nos.jpeg";
import fillmissing from "../../assets/images/Blogs/fill-missing.jpeg";
import findmissing from "../../assets/images/Blogs/missing-one.jpeg";
import compare from "../../assets/images/Blogs/compare-nos.jpeg";
import complete from "../../assets/images/Blogs/complete-nos.jpeg";
import select from "../../assets/images/Blogs/select-alphabet.jpeg";
import completealphabet from "../../assets/images/Blogs/complete-alphabet.jpeg";
import sortalphabet from "../../assets/images/Blogs/sort-alphabet.jpeg";
import match from "../../assets/images/Blogs/match-alphabet.jpeg";
import matchshapes from "../../assets/images/Blogs/match-shape.jpeg";
import completeshapes from "../../assets/images/Blogs/complete-shape.jpeg";
import missingshapes from "../../assets/images/Blogs/missing-shape.jpeg";
import sortcolor from "../../assets/images/Blogs/sort-color.jpeg";
import redcolor from "../../assets/images/Blogs/red-color.jpeg";
import yellowcolor from "../../assets/images/Blogs/yellow-color.jpeg";
import completefruit from "../../assets/images/Blogs/complete-fruit.jpeg";
import completeveg from "../../assets/images/Blogs/complete-veg.jpeg";
import selectfruit from "../../assets/images/Blogs/select-fruit.jpeg";
import chillies from "../../assets/images/Blogs/chillies.jpeg";
import matchanimal from "../../assets/images/Blogs/match-animal.jpeg";
import octo from "../../assets/images/Blogs/octopus.jpeg";
import squir from "../../assets/images/Blogs/squirrel.jpeg";
import different from "../../assets/images/Blogs/different.jpeg";
import miss from "../../assets/images/Blogs/miss.jpeg";
import biggest from "../../assets/images/Blogs/biggest.jpeg";
import smallest from "../../assets/images/Blogs/smallest.jpeg";
import main from "../../assets/images/Blogs/main.jpeg";
import { Link } from "react-router-dom";
import LandingPageHeader from "./LandingPageHeader";
import FloatingStatsForLandingPage from "./FlotingStatsForLandingPage";

const reviews = [
  {
    name: "Preeti Yadav",
    rating: 5,
    text: "Kids love this game's lively animations! It makes learning feel like playtime. Great for keeping little ones engaged and entertained.",
    avatar: "👩👧",
  },
  {
    name: "Sanjeet",
    rating: 5,
    text: "This kids learning game is packed with animation that will keep kids entertained and making learning exciting for kids.",
    avatar: "👨👦",
  },
  {
    name: "AJAY DHADE",
    rating: 5,
    text: "This app is very good for kids because they can study along with playing games on this application.",
    avatar: "👩👦👦",
  },
  {
    name: "Sitaram Mahajan",
    rating: 5,
    text: "This app is a fantastic and engaging way to learn about fruits , animals! The interactive games and vibrant visuals make it easy and fun to discover new fruits, animals their names",
    avatar: "👩👦👦",
  },
];
const NewLandingPage = () => {
  const videoRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 0.8;
    }
  }, []);

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  const ReviewCard = ({ review, positionClass }) => (
    <motion.div
      initial={{ opacity: 0, x: positionClass.includes("left") ? -50 : 50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: 0.5 }}
      className={`hidden md:block absolute ${positionClass} transform -translate-y-1/2 w-72 z-20`}
    >
      <div className="bg-gradient-to-br from-purple-900/80 to-cyan-900/80 p-6 rounded-2xl backdrop-blur-sm border-2 border-cyan-400/30 shadow-xl">
        <div className="flex items-center gap-3 mb-4">
          <div className="text-3xl">{review.avatar}</div>
          <div>
            <h4 className="text-cyan-100 font-bold">{review.name}</h4>
            <div className="flex gap-1 text-yellow-400">
              {[...Array(review.rating)].map((_, i) => (
                <FaStar key={i} className="w-4 h-4" />
              ))}
            </div>
          </div>
        </div>
        <p className="text-cyan-50 italic">"{review.text}"</p>
      </div>
    </motion.div>
  );

  return (
    <div className="min-h-screen bg-gradient-to-br  from-gray-900 via-purple-900 to-gray-900 font-['Comic_Neue'] ">
      <LandingPageHeader />

      {/* Hero Section */}
      <section className="relative flex flex-col items-center justify-center pt-44 pb-8 md:pt-24 md:pb-22 overflow-hidden">
        <div className="relative z-10 text-center px-2 flex-1 flex flex-col items-center justify-center w-full max-w-7xl">
          {/* Reviews positioned around the video */}
          <ReviewCard
            review={reviews[0]}
            positionClass="left-[-5%] top-[10%]"
          />
          <ReviewCard
            review={reviews[1]}
            positionClass="left-[-5%] top-[55%]"
          />
          <ReviewCard
            review={reviews[2]}
            positionClass="right-[-5%] top-[10%]"
          />
          <ReviewCard
            review={reviews[3]}
            positionClass="right-[-5%] top-[47%]"
          />

          {/* Enhanced Main Heading */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="relative mb-8"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-cyan-400/20 to-purple-400/20 blur-3xl opacity-30" />
            <h1 className="text-3xl md:text-6xl font-bold mb-6 leading-tight">
              <span className="bg-gradient-to-r from-yellow-300 to-pink-400 bg-clip-text text-transparent px-2">
                Kids
              </span>
              <span className="text-white px-2">Learning</span>
              <span className="bg-gradient-to-r from-pink-400 to-yellow-300 bg-clip-text text-transparent px-2">
                Games
              </span>
            </h1>
          </motion.div>

          {/* Enhanced Video Container */}
          <motion.div
            className="relative w-full max-w-2xl md:mb-10"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            <div className="relative device-frame bg-gray-800 p-1 rounded-[40px] shadow-2xl transform perspective-1000 border-4 border-white-100/10 hover:border-white-100/40 transition-all">
              {/* Video element with working mute button */}
              <div className="relative rounded-[32px] overflow-hidden aspect-video border-4 border-gray-900/50">
                <video
                  ref={videoRef}
                  className="w-full h-full object-cover"
                  autoPlay
                  muted
                  loop
                  playsInline
                  poster={poster}
                >
                  <source src={trailer} type="video/mp4" />
                </video>
                <button
                  onClick={toggleMute}
                  className="absolute bottom-4 right-4 bg-gray-900/75 p-2 rounded-full text-white hover:bg-gray-700 backdrop-blur-sm z-50"
                >
                  {isMuted ? <VolumeX size={24} /> : <Volume2 size={24} />}
                </button>
              </div>

              {/* Glowing Effects */}
              <div className="absolute -inset-8 bg-gradient-to-r from-cyan-400/20 to-purple-400/20 blur-2xl opacity-20 animate-pulse" />
            </div>
          </motion.div>
        </div>

        <div className="w-full px-4 mt-10 md:mt-10">
          <FloatingStatsForLandingPage />
        </div>
      </section>
      <div class="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-2">
        {/* <!-- Why Choose Section --> */}
        <div class="p-6 md:p-12 bg-gradient-to-r from-purple-700 via-blue-600 to-cyan-700 text-white rounded-2xl ">
          <h2 class="text-3xl font-bold mb-8 font-baloo">
            Why Choose Twepple Kids Educational Games?
          </h2>
          <div class="grid md:grid-cols-2 gap-8">
            <div class="bg-white/10 p-6 rounded-xl">
              <div className="flex flex-row align-center gap-2 md:gap-4 md:mb-2 mb-1">
                <span class="text-xl md:text-2xl">👨‍🏫✔️</span>
                <h3 class="text-xl md:text-2xl font-bold font-baloo">
                  Approved by Teachers Worldwide
                </h3>
              </div>
              <p class="text-md  text-white font-semibold font-baloo">
                Trusted and recommended by educators for safe learning
              </p>
            </div>
            <div class="bg-white/10 p-6 rounded-xl">
              <div className="flex flex-row align-center gap-2 md:gap-4 md:mb-2 mb-1">
                <span class="text-xl md:text-2xl">🎲📚</span>
                <h3 class="text-xl md:text-xl font-bold font-baloo">
                  Fun + Learning Together
                </h3>
              </div>
              <p class="text-md  text-white font-semibold font-baloo">
                Games designed to keep kids entertained and boost brainpower
              </p>
            </div>

            <div class="bg-white/10 p-6 rounded-xl">
              <div className="flex flex-row align-center gap-2 md:gap-4 md:mb-2 mb-1">
                <span class="text-xl md:text-2xl">🔒👶</span>
                <h3 class="text-xl md:text-xl font-bold font-baloo">
                  Safe & Kid-Friendly
                </h3>
              </div>
              <p class="text-md  text-white font-semibold font-baloo">
                100% full version, secure, and suitable for all ages
              </p>
            </div>

            <div class="bg-white/10 p-6 rounded-xl">
              <div className="flex flex-row align-center gap-2 md:gap-4 md:mb-2 mb-1">
                <span class="text-xl md:text-2xl">🎨💡</span>
                <h3 class="text-xl md:text-xl font-bold font-baloo">
                  Boosts Creativity & Imagination
                </h3>
              </div>
              <p class="text-md  text-white font-semibold font-baloo">
                Activities that inspire kids to think outside the box
              </p>
            </div>

            <div class="bg-white/10 p-6 rounded-xl">
              <div className="flex flex-row align-center gap-2 md:gap-4 md:mb-2 mb-1">
                <span class="text-xl md:text-2xl">🧠✨</span>
                <h3 class="text-xl md:text-xl font-bold font-baloo">
                  Improves Focus & Memory
                </h3>
              </div>
              <p class="text-md  text-white font-semibold font-baloo">
                Carefully designed puzzles that strengthen concentration
              </p>
            </div>

            <div class="bg-white/10 p-6 rounded-xl">
              <div className="flex flex-row align-center gap-2 md:gap-4 md:mb-2 mb-1">
                <span class="text-xl md:text-2xl">🔑🧩</span>
                <h3 class="text-xl md:text-xl font-bold  font-baloo">
                  Develops Problem-Solving Skills
                </h3>
              </div>
              <p class="text-md  text-white font-semibold font-baloo">
                Challenges kids to think critically and solve fun problems
              </p>
            </div>

            <div class="bg-white/10 p-6 rounded-xl">
              <div className="flex flex-row align-center gap-2 md:gap-4 md:mb-2 mb-1">
                <span class="text-xl md:text-2xl">📱💻</span>
                <h1 class="text-xl md:text-xl font-bold font-baloo">
                  Play Anytime, Anywhere
                </h1>
              </div>
              <p class="text-md  text-white font-semibold font-baloo">
                Available on mobile, tablet, and desktop for flexible learning
              </p>
            </div>

            <div class="bg-white/10 p-6 rounded-xl">
              <div className="flex flex-row align-center gap-2 md:gap-4 md:mb-2 mb-1">
                <span class="text-xl md:text-2xl">❤️👨‍👩‍👧</span>
                <h3 class="text-xl md:text-xl font-bold font-baloo">
                  Parental Peace of Mind
                </h3>
              </div>
              <p class="text-md text-white font-semibold font-baloo">
                Easy progress tracking so parents know what kids are learning
              </p>
            </div>
          </div>
        </div>

        <div className="mt-8">
          <a
            href="https://TweppleKids.short.gy/KidsLearningApp"
            target="_blank"
            rel="noopener noreferrer"
            class="w-full my-6 bg-emerald-500 hover:bg-emerald-600 text-white rounded-2xl py-2 px-4 
                                transform transition-all duration-300 hover:scale-105 active:scale-95 
                                shadow-lg hover:shadow-xl flex items-center justify-center gap-4
                                animate-bounce hover:animate-none"
            aria-label="Download Toddler's Learning Game"
          >
            {/* <!-- Animated game controller icon --> */}
            <svg
              className="w-12 h-12 flex-shrink-0 animate-pulse text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
              />
            </svg>
            <span class="text-3xl text-white font-bold tracking-wide">
              Download Now!
            </span>
          </a>
        </div>

        <section class="mb-16">
          {/* <!-- Main Features --> */}
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
            <div>
              <h2 class="text-3xl font-bold text-white mb-2 md:mb-6 pt-2 flex items-center ">
                <span class="text-blue-600 rounded-full mr-3">🌍</span>
                29+ Languages , 100% Free Forever
              </h2>

              <div class="bg-white p-2 md:p-4 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                <img src={noads} alt="Ad-free experience" class="rounded-lg " />
              </div>
            </div>
            <div>
              <h2 class="text-3xl font-bold text-white mb-2 md:mb-6 pt-2 flex items-center ">
                <span class="text-blue-600 rounded-full mr-3">📚</span>
                Comprehensive Learning
              </h2>

              <div class="bg-white p-2 md:p-4 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                <img src={main} alt="Core learning" class="rounded-lg " />
              </div>
            </div>
          </div>

          {/* <!-- Numbers Games Section --> */}
          <div className="mt-2">
            <h3 class="text-2xl md:text-3xl font-bold text-gray-200 mb-6 flex items-center gap-2">
              <span class="bg-gray-100 p-2 rounded-lg font-baloo">🔢</span>
              Numbers & Math Games
            </h3>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* <!-- Numbers game entries here --> */}
              <div className="mb-2">
                <h3 class="pl-2 text-2xl font-bold text-white mb-2 flex items-center font-baloo ">
                  Count the Objects
                </h3>
                <div class="bg-white p-2 md:p-4 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                  <img src={count} alt="Count Objects" class="rounded-lg " />
                </div>
              </div>

              <div className="mb-2">
                <h3 class="pl-2 text-2xl font-bold text-white mb-2 flex items-center font-baloo ">
                  Subtract the numbers
                </h3>
                <div class="bg-white p-2 md:p-4 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                  <img
                    src={subtract}
                    alt="Subtract the numbers"
                    class="rounded-lg "
                  />
                </div>
              </div>

              <div className="mb-2">
                <h3 class="pl-2 text-2xl font-bold text-white mb-2 flex items-center font-baloo ">
                  Add the numbers
                </h3>
                <div class="bg-white p-2 md:p-4 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                  <img src={add} alt="Add the numbers" class="rounded-lg" />
                </div>
              </div>

              <div className="mb-2">
                <h3 class="pl-2 text-2xl font-bold text-white mb-2 flex items-center font-baloo ">
                  Fill the missing one
                </h3>
                <div class="bg-white p-2 md:p-4 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                  <img
                    src={fillmissing}
                    alt="Add the numbers"
                    class="rounded-lg"
                  />
                </div>
              </div>
              <div className="mb-2">
                <h3 class="pl-2 text-2xl font-bold text-white mb-2 flex items-center font-baloo ">
                  Find the missing one
                </h3>
                <div class="bg-white p-2 md:p-4 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                  <img
                    src={findmissing}
                    alt="Add the numbers"
                    class="rounded-lg"
                  />
                </div>
              </div>
              <div className="mb-2">
                <h3 class="pl-2 text-2xl font-bold text-white mb-2 flex items-center font-baloo ">
                  Compare the numbers
                </h3>
                <div class="bg-white p-2 md:p-4 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                  <img src={compare} alt="Add the numbers" class="rounded-lg" />
                </div>
              </div>

              <div className="mb-2">
                <h3 class="pl-2 text-2xl font-bold text-white mb-2 flex items-center font-baloo ">
                  Complete the sequence
                </h3>
                <div class="bg-white p-2 md:p-4 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                  <img
                    src={complete}
                    alt="Add the numbers"
                    class="rounded-lg"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Alphabet Games Section --> */}
          <div className="mt-8">
            <h3 class="text-2xl md:text-3xl font-bold text-gray-200 mb-6 flex items-center gap-2">
              <span class="bg-gray-100 p-2 rounded-lg font-baloo">🔤</span>
              Alphabet & Language Games
            </h3>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* <!-- Alphabet game entries here --> */}

              <div className="mb-2">
                <h3 class="pl-2 text-2xl font-bold text-white mb-2 flex items-center font-baloo ">
                  Letter Recognition
                </h3>
                <div class="bg-white p-2 md:p-4 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                  <img src={select} alt="Add the numbers" class="rounded-lg" />
                </div>
              </div>

              <div className="mb-2">
                <h3 class="pl-2 text-2xl font-bold text-white mb-2 flex items-center font-baloo ">
                  Match the alphabets
                </h3>
                <div class="bg-white p-2 md:p-4 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                  <img src={match} alt="Add the numbers" class="rounded-lg" />
                </div>
              </div>

              <div className="mb-2">
                <h3 class="pl-2 text-2xl font-bold text-white mb-2 flex items-center font-baloo ">
                  Complete the sequence
                </h3>
                <div class="bg-white p-2 md:p-4 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                  <img
                    src={completealphabet}
                    alt="Add the numbers"
                    class="rounded-lg"
                  />
                </div>
              </div>

              <div className="mb-2">
                <h3 class="pl-2 text-2xl font-bold text-white mb-2 flex items-center font-baloo ">
                  Sort the alphabets
                </h3>
                <div class="bg-white p-2 md:p-4 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                  <img
                    src={sortalphabet}
                    alt="Add the numbers"
                    class="rounded-lg"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Shapes & Colors Section --> */}

          <div className="mt-8">
            <h3 class="text-2xl md:text-3xl font-bold text-gray-200 mb-6 flex items-center gap-2">
              <span class="bg-gray-100 p-2 rounded-lg font-baloo">🔤</span>
              Shapes & Colors
            </h3>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* <!-- Shape/color games --> */}

              <div className="mb-2">
                <h3 class="pl-2 text-2xl font-bold text-white mb-2 flex items-center font-baloo ">
                  Shape Matching
                </h3>
                <div class="bg-white p-2 md:p-4 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                  <img
                    src={matchshapes}
                    alt="Add the numbers"
                    class="rounded-lg"
                  />
                </div>
              </div>

              <div className="mb-2">
                <h3 class="pl-2 text-2xl font-bold text-white mb-2 flex items-center font-baloo ">
                  Complete the shapes
                </h3>
                <div class="bg-white p-2 md:p-4 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                  <img
                    src={completeshapes}
                    alt="Add the numbers"
                    class="rounded-lg"
                  />
                </div>
              </div>

              <div className="mb-2">
                <h3 class="pl-2 text-2xl font-bold text-white mb-2 flex items-center font-baloo ">
                  Find the similar missing one
                </h3>
                <div class="bg-white p-2 md:p-4 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                  <img
                    src={missingshapes}
                    alt="Add the numbers"
                    class="rounded-lg"
                  />
                </div>
              </div>

              <div className="mb-2">
                <h3 class="pl-2 text-2xl font-bold text-white mb-2 flex items-center font-baloo ">
                  Find the Orange color from the objects
                </h3>
                <div class="bg-white p-2 md:p-4 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                  <img
                    src={redcolor}
                    alt="Add the numbers"
                    class="rounded-lg"
                  />
                </div>
              </div>

              <div className="mb-2">
                <h3 class="pl-2 text-2xl font-bold text-white mb-2 flex items-center font-baloo ">
                  Find the Yellow color
                </h3>
                <div class="bg-white p-2 md:p-4 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                  <img
                    src={yellowcolor}
                    alt="Add the numbers"
                    class="rounded-lg"
                  />
                </div>
              </div>

              <div className="mb-2">
                <h3 class="pl-2 text-2xl font-bold text-white mb-2 flex items-center font-baloo ">
                  Sort the colors
                </h3>
                <div class="bg-white p-2 md:p-4 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                  <img
                    src={sortcolor}
                    alt="Add the numbers"
                    class="rounded-lg"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Nature & Animals Section --> */}
          <div className="mt-8">
            <h3 class="text-2xl md:text-3xl font-bold text-gray-200 mb-6 flex items-center gap-2">
              <span class="bg-gray-100 p-2 rounded-lg font-baloo">🔤</span>
              Animals, Fruits & Vegetables
            </h3>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* <!-- Animal/nature games --> */}

              <div className="mb-2">
                <h3 class="pl-2 text-2xl font-bold text-white mb-2 flex items-center font-baloo ">
                  Select the animal - Butterfly
                </h3>
                <div class="bg-white p-2 md:p-4 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                  <img src={octo} alt="Add the numbers" class="rounded-lg" />
                </div>
              </div>

              <div className="mb-2">
                <h3 class="pl-2 text-2xl font-bold text-white mb-2 flex items-center font-baloo ">
                  Select the animal - Lion
                </h3>
                <div class="bg-white p-2 md:p-4 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                  <img src={squir} alt="Add the numbers" class="rounded-lg" />
                </div>
              </div>

              <div className="mb-2">
                <h3 class="pl-2 text-2xl font-bold text-white mb-2 flex items-center font-baloo ">
                  Match the animals
                </h3>
                <div class="bg-white p-2 md:p-4 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                  <img
                    src={matchanimal}
                    alt="Add the numbers"
                    class="rounded-lg"
                  />
                </div>
              </div>

              <div className="mb-2">
                <h3 class="pl-2 text-2xl font-bold text-white mb-2 flex items-center font-baloo ">
                  Complete the fruits
                </h3>
                <div class="bg-white p-2 md:p-4 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                  <img
                    src={completefruit}
                    alt="Add the numbers"
                    class="rounded-lg"
                  />
                </div>
              </div>

              <div className="mb-2">
                <h3 class="pl-2 text-2xl font-bold text-white mb-2 flex items-center font-baloo ">
                  Select the fruit - Watermelon
                </h3>
                <div class="bg-white p-2 md:p-4 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                  <img
                    src={selectfruit}
                    alt="Add the numbers"
                    class="rounded-lg"
                  />
                </div>
              </div>

              <div className="mb-2">
                <h3 class="pl-2 text-2xl font-bold text-white mb-2 flex items-center font-baloo ">
                  Complete the vegetable
                </h3>
                <div class="bg-white p-2 md:p-4 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                  <img
                    src={completeveg}
                    alt="Add the numbers"
                    class="rounded-lg"
                  />
                </div>
              </div>

              <div className="mb-2">
                <h3 class="pl-2 text-2xl font-bold text-white mb-2 flex items-center font-baloo ">
                  Select the vegetable - Tomato
                </h3>
                <div class="bg-white p-2 md:p-4 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                  <img
                    src={chillies}
                    alt="Add the numbers"
                    class="rounded-lg"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Logical Thinking Section --> */}

          <div className="mt-8">
            <h3 class="text-2xl md:text-3xl font-bold text-gray-200 mb-6 flex items-center gap-2">
              <span class="bg-gray-100 p-2 rounded-lg font-baloo">🔤</span>
              Logic & Problem Solving
            </h3>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* <!-- Logic games --> */}

              <div className="mb-2">
                <h3 class="pl-2 text-2xl font-bold text-white mb-2 flex items-center font-baloo ">
                  Select the Smallest One
                </h3>
                <div class="bg-white p-2 md:p-4 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                  <img
                    src={smallest}
                    alt="Add the numbers"
                    class="rounded-lg"
                  />
                </div>
              </div>

              <div className="mb-2">
                <h3 class="pl-2 text-2xl font-bold text-white mb-2 flex items-center font-baloo ">
                  Select the Biggest One
                </h3>
                <div class="bg-white p-2 md:p-4 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                  <img src={biggest} alt="Add the numbers" class="rounded-lg" />
                </div>
              </div>

              <div className="mb-2">
                <h3 class="pl-2 text-2xl font-bold text-white mb-2 flex items-center font-baloo ">
                  Find the Missing One
                </h3>
                <div class="bg-white p-2 md:p-4 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                  <img src={miss} alt="Add the numbers" class="rounded-lg" />
                </div>
              </div>

              <div className="mb-2">
                <h3 class="pl-2 text-2xl font-bold text-white mb-2 flex items-center font-baloo ">
                  Find the Different One
                </h3>
                <div class="bg-white p-2 md:p-4 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                  <img
                    src={different}
                    alt="Add the numbers"
                    class="rounded-lg"
                  />
                </div>
              </div>
            </div>
            <h1 class="text-gray-100 text-xl mt-5 flex justify-center">
              And many more ....
            </h1>
          </div>
        </section>
      </div>

      <footer className="bg-gray-900/80 backdrop-blur-2xl pt-24 pb-12 border-t border-cyan-900/20">
        {/* Enhanced Bottom Bar */}
        <div className="border-t border-cyan-900/20  pt-8 relative">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-gradient-to-r from-cyan-400 to-purple-400 w-24 h-1 rounded-full" />

          <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-4 text-gray-400 text-base">
            <div className="flex items-center gap-3">
              <span className="text-2xl">🎮</span>
              <div className="mb-4 md:mb-0 text-center">
                © {new Date().getFullYear()} Twepple Kids
              </div>
            </div>

            <div className="flex items-center gap-6">
              <Link
                to="/privacyPolicy"
                className="hover:text-cyan-300 transition-colors font-medium flex items-center gap-2 group"
              >
                <span>Your Privacy Matters</span>
                <span className="group-hover:translate-x-1 transition-transform">
                  🔒
                </span>
              </Link>
            </div>

            <div className="flex items-center gap-2 text-sm">
              <span>Made with</span>
              <FaRegHeart className="text-red-500" />
              <span>for Kids</span>
              <span className="text-xl">👧👦</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default NewLandingPage;
